import InputField from '../../inputs/inputField'

export default function RollupForm({ formData }: { formData: any }) {
	return (
		<div className="hidden w-full gap-y-2">
			<InputField
				name="rollup cid"
				type="text"
				containerWidth="w-full"
				value={formData.rollupCID}
				placeholder=""
			/>
		</div>
	)
}
